import OrderDTO from "@/dto/order/OrderDTO";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import { useGlobalStore } from "@/store/hooks";
import { isEmpty } from "@/utils";
import { CaretUpOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";

interface OrderPrintInfoProps {
    colSpan: number;
    order: OrderDTO;
}

const OrderPrintInfo: React.FC<OrderPrintInfoProps> = function (props) {
    const { order, colSpan } = props;
    const globalStore = useGlobalStore();
    const [expanded, setExpanded] = useState(false);

    const toggleExpand = (e: React.MouseEvent) => {
        /** 阻止选中订单 */
        e.stopPropagation();
        setExpanded(!expanded);
    };

    return (
        <tr>
            <td colSpan={colSpan}>
                <div style={{ marginBottom: 12 }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "14px 16px",
                            border: "1px solid #e8e8e8",
                            borderRadius: 4,
                        }}
                    >
                        <div>
                            <div style={{ marginBottom: expanded ? 8 : 0 }}>
                                快递单上打印的商品信息
                                <span style={{ color: "#666", fontSize: 13 }}>
                                    （手工编辑后请立即打印，刷新后将恢复默认内容）
                                </span>
                                <Button
                                    type="text"
                                    size="small"
                                    onClickCapture={toggleExpand}
                                    style={{
                                        padding: 0,
                                        color: "#1890ff",
                                        marginLeft: 12,
                                        height: "auto",
                                        alignSelf: expanded ? "flex-start" : "center",
                                        fontSize: "12px",
                                    }}
                                >
                                    {expanded ? "收起" : "展开"}
                                    <CaretUpOutlined
                                        style={{
                                            fontSize: 12,
                                            marginLeft: 4,
                                            transform: expanded ? "rotate(0)" : "rotate(180deg)",
                                            transition: "transform 0.3s",
                                        }}
                                    />
                                </Button>
                            </div>

                            {expanded && (
                                <Input.TextArea
                                    style={{ fontSize: 12 }}
                                    value={order.customPrintingOrderItemInfo}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        order.customPrintingOrderItemInfo = value;
                                    }}
                                    onBlur={() => {
                                        if (isEmpty(order.customPrintingOrderItemInfo)) return;

                                        if (order.customPrintingOrderItemInfo) {
                                            const shop = globalStore.shopMapping.get(order.shopId);

                                            collectEvent(DataTrackEvent.SAVE_CUSTOM_PRINT_CONTENT, {
                                                content: order.customPrintingOrderItemInfo,
                                                shop_id: order.shopId,
                                                shop_name: shop.name,
                                                shop_type: ShopTypeNameMap[shop.type],
                                            });
                                        }
                                    }}
                                    placeholder="快递单上的商品信息默认使用模板预设的「商品信息」格式打印，若手工编辑，则按实际编辑后的内容进行打印，常用于商品属性修改，补发等"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
};

export default observer(OrderPrintInfo);
